(function () {
  function closest(el, selector) {
    return el && el.closest ? el.closest(selector) : null;
  }

  function updateNavState(track) {
    if (!track) return;
    var wrap = track.parentElement;
    if (!wrap) return;
    var prev = wrap.querySelector('[data-lwp-thumb-prev]');
    var next = wrap.querySelector('[data-lwp-thumb-next]');
    var maxScroll = track.scrollWidth - track.clientWidth;
    if (prev) prev.disabled = track.scrollLeft <= 1;
    if (next) next.disabled = track.scrollLeft >= maxScroll - 1;
  }

  function scrollThumbs(track, direction) {
    if (!track) return;
    var firstThumb = track.querySelector('[data-lwp-thumb]');
    var step = firstThumb ? firstThumb.offsetWidth + 12 : track.clientWidth * 0.5;
    track.scrollBy({ left: direction * step * 2, behavior: 'smooth' });
  }

  function getGalleryItems(gallery) {
    return gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-lwp-main-media]')) : [];
  }

  function getGalleryThumbs(gallery) {
    return gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-lwp-thumb]')) : [];
  }

  function getActiveGalleryIndex(gallery) {
    var items = getGalleryItems(gallery);
    var activeIndex = items.findIndex(function (item) {
      return item.classList.contains('is-active');
    });
    return activeIndex >= 0 ? activeIndex : 0;
  }

  function updateMainGalleryNav(gallery) {
    if (!gallery) return;
    var items = getGalleryItems(gallery);
    var prev = gallery.querySelector('[data-lwp-main-prev]');
    var next = gallery.querySelector('[data-lwp-main-next]');
    var hasMultiple = items.length > 1;

    // Keep both mobile gallery arrows visible like the Strands carousel.
    // Navigation wraps at the beginning/end instead of disabling one side.
    [prev, next].forEach(function (button) {
      if (!button) return;
      button.hidden = !hasMultiple;
      button.disabled = false;
      button.setAttribute('aria-disabled', hasMultiple ? 'false' : 'true');
    });
  }

  function setActiveGalleryIndex(gallery, targetIndex) {
    if (!gallery) return;
    var items = getGalleryItems(gallery);
    var thumbs = getGalleryThumbs(gallery);
    if (!items.length) return;

    targetIndex = Math.max(0, Math.min(targetIndex, items.length - 1));

    items.forEach(function (item, index) {
      var isTarget = index === targetIndex;
      item.classList.toggle('is-active', isTarget);
      if (!isTarget) {
        item.querySelectorAll('video').forEach(function (video) {
          try { video.pause(); } catch (error) {}
        });
      }
    });

    thumbs.forEach(function (thumb, index) {
      thumb.classList.toggle('is-active', index === targetIndex);
    });

    var activeThumb = thumbs[targetIndex];
    if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    updateMainGalleryNav(gallery);
  }

  function setActiveGalleryMediaById(gallery, mediaId) {
    if (!gallery || !mediaId) return;
    var items = getGalleryItems(gallery);
    var targetIndex = items.findIndex(function (item) {
      return item.dataset.mediaId === mediaId;
    });
    if (targetIndex >= 0) {
      setActiveGalleryIndex(gallery, targetIndex);
    }
  }

  function moveGallery(gallery, direction) {
    if (!gallery) return;
    var items = getGalleryItems(gallery);
    if (!items.length) return;
    var currentIndex = getActiveGalleryIndex(gallery);
    var targetIndex = (currentIndex + direction + items.length) % items.length;
    setActiveGalleryIndex(gallery, targetIndex);
  }

  function bindGallerySwipe(gallery) {
    var main = gallery ? gallery.querySelector('[data-lwp-main-gallery]') : null;
    if (!main || main.dataset.swipeBound === 'true') return;

    var startX = 0;
    var startY = 0;
    main.dataset.swipeBound = 'true';

    main.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      startX = event.changedTouches[0].clientX;
      startY = event.changedTouches[0].clientY;
    }, { passive: true });

    main.addEventListener('touchend', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      var endX = event.changedTouches[0].clientX;
      var endY = event.changedTouches[0].clientY;
      var deltaX = endX - startX;
      var deltaY = endY - startY;

      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      moveGallery(gallery, deltaX < 0 ? 1 : -1);
    }, { passive: true });
  }

  function formatWattzMoney(cents, priceEl) {
    var amount = (Number(cents) || 0) / 100;
    var currency = (priceEl && priceEl.dataset.currencyCode) || 'EUR';
    var localeCode = (priceEl && priceEl.dataset.locale) || document.documentElement.lang || 'de';

    try {
      return new Intl.NumberFormat(localeCode, {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol'
      }).format(amount);
    } catch (error) {
      return '€' + amount.toFixed(2).replace('.', ',');
    }
  }


  function getFormControl(form, name) {
    if (!form || !form.elements) return null;
    var control = form.elements[name];
    if (!control) return null;
    if (control instanceof RadioNodeList) return control[0] || null;
    return control;
  }

  function buildLwpCheckoutPermalink(button) {
    var form = closest(button, 'form');
    if (!form) return null;

    var variantInput = getFormControl(form, 'id') || form.querySelector('[name="id"]');
    var qtyInput = getFormControl(form, 'quantity') || form.querySelector('[name="quantity"]');
    var variantId = variantInput && variantInput.value ? String(variantInput.value).trim() : '';
    var quantity = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10);

    if (!variantId) return null;
    if (Number.isNaN(quantity) || quantity < 1) quantity = 1;

    var items = [variantId + ':' + quantity];
    var root = closest(button, '[data-led-wattz-product]') || document;
    var bundleWrap = root.querySelector('.lwp-pair-bundle__form[data-bundle-variant-id]');

    if (bundleWrap && bundleWrap.dataset.bundleAvailable === 'true') {
      var bundleVariantId = bundleWrap.dataset.bundleVariantId;
      var bundleQtyInput = bundleWrap.querySelector('.lwp-pair-bundle__qty-input');
      var bundleQty = parseInt(bundleQtyInput && bundleQtyInput.value ? bundleQtyInput.value : '0', 10);

      if (bundleVariantId && !Number.isNaN(bundleQty) && bundleQty > 0) {
        items.push(bundleVariantId + ':' + bundleQty);
      }
    }

    var localeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return localeRoot + 'cart/' + items.join(',') + '?checkout';
  }

  function goToLwpCheckout(button) {
    var permalink = buildLwpCheckoutPermalink(button);
    if (!permalink) return;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    window.location.href = permalink;
  }

  function updateMobileStickyTotal(root) {
    root = root || document.querySelector('[data-led-wattz-product]') || document;

    var bundleWrap = root.querySelector('.lwp-pair-bundle__form[data-bundle-price-cents]');
    var bundlePrice = bundleWrap ? Number(bundleWrap.dataset.bundlePriceCents || 0) : 0;
    var bundleQtyInput = bundleWrap ? bundleWrap.querySelector('.lwp-pair-bundle__qty-input') : null;
    var bundleQty = parseInt(bundleQtyInput && bundleQtyInput.value ? bundleQtyInput.value : '0', 10);
    if (Number.isNaN(bundleQty) || bundleQty < 0) bundleQty = 0;

    function getTotalCents(priceEl, qtyInput) {
      if (!priceEl) return 0;
      var mainPrice = Number(priceEl.dataset.mainPriceCents || 0);
      var mainQty = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10);
      if (Number.isNaN(mainQty) || mainQty < 1) mainQty = 1;
      return (mainPrice * mainQty) + (bundlePrice * bundleQty);
    }

    function updatePrice(priceEl, qtyInput) {
      if (!priceEl) return 0;
      var totalCents = getTotalCents(priceEl, qtyInput);
      priceEl.textContent = formatWattzMoney(totalCents, priceEl);
      return totalCents;
    }

    var desktopPriceEl = root.querySelector('[data-lwp-desktop-total-price]');
    var desktopQtyInput = root.querySelector('.lwp-form-row [data-lwp-qty] input[type="number"]');
    updatePrice(desktopPriceEl, desktopQtyInput);

    var mobilePriceEl = root.querySelector('[data-lwp-mobile-total-price]');
    var stickyQtyInput = root.querySelector('.lwp-mobile-sticky__qty input[type="number"]');
    updatePrice(mobilePriceEl, stickyQtyInput);

    var klarnaBox = root.querySelector('[data-lwp-klarna-box]');
    var klarnaModal = root.querySelector('[data-lwp-klarna-modal]');
    if (klarnaBox || klarnaModal) {
      var useMobileQty = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
      var klarnaPriceEl = useMobileQty && mobilePriceEl ? mobilePriceEl : (desktopPriceEl || mobilePriceEl);
      var klarnaQtyInput = useMobileQty && stickyQtyInput ? stickyQtyInput : (desktopQtyInput || stickyQtyInput);
      var klarnaTotalCents = getTotalCents(klarnaPriceEl, klarnaQtyInput);
      var installmentCents = Math.round(klarnaTotalCents / 3);
      var moneyContext = klarnaBox || klarnaModal || desktopPriceEl || mobilePriceEl;

      root.querySelectorAll('[data-lwp-klarna-installment], [data-lwp-klarna-plan-installment]').forEach(function (el) {
        el.textContent = formatWattzMoney(installmentCents, moneyContext);
      });

      root.querySelectorAll('[data-lwp-klarna-total], [data-lwp-klarna-pay-full]').forEach(function (el) {
        el.textContent = formatWattzMoney(klarnaTotalCents, moneyContext);
      });
    }
  }

  function openKlarnaModal(root) {
    if (!root) return;
    updateMobileStickyTotal(root);
    var modal = root.querySelector('[data-lwp-klarna-modal]');
    if (!modal) return;
    modal.hidden = false;
    modal.classList.add('is-open');
    document.documentElement.classList.add('lwp-klarna-modal-open');

    var panel = modal.querySelector('.lwp-klarna-modal__panel');
    window.setTimeout(function () {
      if (panel) panel.focus();
    }, 20);
  }

  function closeKlarnaModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.documentElement.classList.remove('lwp-klarna-modal-open');
  }

  // Initialize thumbnail rails and gallery swipe / nav state
  document.querySelectorAll('[data-lwp-thumbs-track]').forEach(function (track) {
    updateNavState(track);
    track.addEventListener('scroll', function () { updateNavState(track); }, { passive: true });
  });

  document.querySelectorAll('.lwp-gallery').forEach(function (gallery) {
    bindGallerySwipe(gallery);
    updateMainGalleryNav(gallery);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-lwp-thumbs-track]').forEach(updateNavState);
    document.querySelectorAll('.lwp-gallery').forEach(updateMainGalleryNav);
    document.querySelectorAll('[data-led-wattz-product]').forEach(function (root) {
      updateMobileStickyTotal(root);
    });
  });

  document.addEventListener('click', function (event) {
    var directCheckoutButton = closest(event.target, '[data-lwp-direct-checkout]');
    if (directCheckoutButton) {
      event.preventDefault();
      goToLwpCheckout(directCheckoutButton);
      return;
    }

    var klarnaOpen = closest(event.target, '[data-lwp-klarna-open]');
    if (klarnaOpen) {
      event.preventDefault();
      openKlarnaModal(closest(klarnaOpen, '[data-led-wattz-product]') || document);
      return;
    }

    var klarnaClose = closest(event.target, '[data-lwp-klarna-close]');
    if (klarnaClose) {
      event.preventDefault();
      closeKlarnaModal(closest(klarnaClose, '[data-lwp-klarna-modal]'));
      return;
    }

    // Thumbnail rail arrows (if used anywhere)
    var prevBtn = closest(event.target, '[data-lwp-thumb-prev]');
    var nextBtn = closest(event.target, '[data-lwp-thumb-next]');
    if (prevBtn || nextBtn) {
      var wrap = closest(event.target, '.lwp-gallery__thumbs-wrap');
      if (!wrap) return;
      var track = wrap.querySelector('[data-lwp-thumbs-track]');
      scrollThumbs(track, prevBtn ? -1 : 1);
      return;
    }

    // Main image arrows
    var mainPrev = closest(event.target, '[data-lwp-main-prev]');
    var mainNext = closest(event.target, '[data-lwp-main-next]');
    if (mainPrev || mainNext) {
      var gallery = closest(event.target, '.lwp-gallery');
      moveGallery(gallery, mainPrev ? -1 : 1);
      return;
    }

    // Thumbnail click → switch main media + mark active (supports images and videos)
    var thumb = closest(event.target, '[data-lwp-thumb]');
    if (thumb) {
      var gallery = closest(thumb, '.lwp-gallery');
      setActiveGalleryMediaById(gallery, thumb.dataset.mediaId);
      return;
    }

    var tabButton = closest(event.target, '.lwp-tab__header');
    if (tabButton) {
      var tab = closest(tabButton, '.lwp-tab');
      if (!tab) return;
      var isOpen = tab.classList.toggle('is-open');
      tabButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    var minus = closest(event.target, '[data-lwp-qty-minus]');
    var plus = closest(event.target, '[data-lwp-qty-plus]');
    if (minus || plus) {
      var qty = closest(event.target, '[data-lwp-qty]');
      if (!qty) return;
      var input = qty.querySelector('input[type="number"]');
      if (!input) return;
      var value = parseInt(input.value || '1', 10);
      if (Number.isNaN(value)) value = 1;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var maxAttr = input.getAttribute('max');
      var max = maxAttr ? parseInt(maxAttr, 10) : null;
      value = plus ? value + 1 : value - 1;
      if (value < min) value = min;
      if (max && value > max) value = max;
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateMobileStickyTotal(closest(input, '[data-led-wattz-product]') || document);
      return;
    }

    var bundleMinus = closest(event.target, '[data-lwp-bundle-minus]');
    var bundlePlus = closest(event.target, '[data-lwp-bundle-plus]');
    if (bundleMinus || bundlePlus) {
      var bundleQty = closest(event.target, '[data-lwp-bundle-qty]');
      if (!bundleQty) return;
      var bundleInput = bundleQty.querySelector('input[type="number"]');
      if (!bundleInput) return;
      var bundleValue = parseInt(bundleInput.value || '0', 10);
      if (Number.isNaN(bundleValue)) bundleValue = 0;
      var bundleMin = parseInt(bundleInput.getAttribute('min') || '0', 10);
      var bundleMaxAttr = bundleInput.getAttribute('max');
      var bundleMax = bundleMaxAttr ? parseInt(bundleMaxAttr, 10) : null;
      bundleValue = bundlePlus ? bundleValue + 1 : bundleValue - 1;
      if (bundleValue < bundleMin) bundleValue = bundleMin;
      if (bundleMax && bundleValue > bundleMax) bundleValue = bundleMax;
      bundleInput.value = bundleValue;
      bundleInput.dispatchEvent(new Event('change', { bubbles: true }));
      updateMobileStickyTotal(closest(bundleInput, '[data-led-wattz-product]') || document);
      return;
    }
  });

  document.addEventListener('change', function (event) {
    var bundleInput = closest(event.target, '.lwp-pair-bundle__qty-input');
    if (!bundleInput) return;
    var value = parseInt(bundleInput.value || '0', 10);
    if (Number.isNaN(value) || value < 0) value = 0;
    var maxAttr = bundleInput.getAttribute('max');
    if (maxAttr) {
      var max = parseInt(maxAttr, 10);
      if (!Number.isNaN(max) && value > max) value = max;
    }
    bundleInput.value = value;
    updateMobileStickyTotal(closest(bundleInput, '[data-led-wattz-product]') || document);
  });

  document.addEventListener('input', function (event) {
    var qtyInput = closest(event.target, '.lwp-qty input[type="number"], .lwp-pair-bundle__qty-input');
    if (!qtyInput) return;
    updateMobileStickyTotal(closest(qtyInput, '[data-led-wattz-product]') || document);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-lwp-klarna-modal].is-open').forEach(function (modal) {
      closeKlarnaModal(modal);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-led-wattz-product]').forEach(function (root) {
      updateMobileStickyTotal(root);
    });
  });
})();
